import { type SchedulingSlot } from '../../../../models/Scheduling'
import { toLocalISODate } from '../../../../common/dateUtils'

// A proposed time slot in the schedule-meeting flow form (not persisted; the booking carries start/end).
export interface BookingSlot {
  startAt: string
  endAt: string
}

export const dayKey = (day: Date): string => toLocalISODate(day)

export const monthBounds = (monthDate: Date): { dateFrom: string; dateTo: string } => {
  const start = new Date(monthDate.getFullYear(), monthDate.getMonth(), 1)
  const end = new Date(monthDate.getFullYear(), monthDate.getMonth() + 1, 1)
  return { dateFrom: start.toISOString(), dateTo: end.toISOString() }
}

export const groupSlotsByDay = (slots: SchedulingSlot[]): Map<string, BookingSlot[]> => {
  const sorted = [...slots].sort((a, b) => new Date(a.start).getTime() - new Date(b.start).getTime())
  const byDay = new Map<string, BookingSlot[]>()
  const seen = new Set<string>()
  for (const slot of sorted) {
    const slotKey = `${slot.start}/${slot.end}`
    if (seen.has(slotKey)) {
      continue
    }
    seen.add(slotKey)
    const key = dayKey(new Date(slot.start))
    const daySlots = byDay.get(key) ?? []
    daySlots.push({ startAt: slot.start, endAt: slot.end })
    byDay.set(key, daySlots)
  }
  return byDay
}

export const firstAvailableDay = (slots: SchedulingSlot[]): Date | null => {
  if (slots.length === 0) {
    return null
  }
  const earliest = slots.reduce((min, slot) => (new Date(slot.start).getTime() < new Date(min.start).getTime() ? slot : min))
  return new Date(earliest.start)
}
